import { combineReducers } from 'redux';

import {
    getAuthReducer, INITIAL_AUTH_STATE
} from '../../auth';
import {
    configurationsReducer,
    INITIAL_CONFIGURATION_STATE
} from '../../configuration';
import { INITIAL_SESSION_STATE } from '../../session';
import { sessionReducer } from '../../session/session.reducer';
import {
    getUserProfilesReducer, INITIAL_USER_PROFILES_STATE
} from '../../user-profiles';
import { AppState } from '../app.types';
import {
    modalManagerReducer, INITIAL_MODAL_MANAGER_STATE
} from '../components';
import {
    getDucsContentReducer, INITIAL_DUCS_STATE
} from '../components/modals/variants/ducs';
import {
    userProfilePictureReducer, INITIAL_USER_PROFILE_PICTURE_STATE
} from '../components/modals/variants/profile-picture-upload-modal';
import {
    userProfileModalReducer, INITIAL_USER_PROFILE_MODAL_STATE
} from '../components/modals/variants/user-profile-modal';
import {
    getNotificationsReducer, INITIAL_NOTIFICATIONS_STATE
} from '../components/notifications';
import {
    appInitializationReducer, INITIAL_APPLICATION_STATE
} from '../state/app-initialization';

export const getRootReducer = () => {
    return combineReducers<AppState>({
        app: appInitializationReducer,
        session: sessionReducer,
        auth: getAuthReducer(),
        configuration: configurationsReducer,
        userProfiles: getUserProfilesReducer(),
        userProfileModal: userProfileModalReducer(),
        modalManager: modalManagerReducer,
        notifications: getNotificationsReducer(),
        profilePicture: userProfilePictureReducer,
        ducs: getDucsContentReducer()
    });
};

export const INITIAL_APP_STATE: AppState = {
    app: INITIAL_APPLICATION_STATE,
    session: INITIAL_SESSION_STATE,
    auth: INITIAL_AUTH_STATE,
    configuration: INITIAL_CONFIGURATION_STATE,
    userProfiles: INITIAL_USER_PROFILES_STATE,
    userProfileModal: INITIAL_USER_PROFILE_MODAL_STATE,
    modalManager: INITIAL_MODAL_MANAGER_STATE,
    notifications: INITIAL_NOTIFICATIONS_STATE,
    profilePicture: INITIAL_USER_PROFILE_PICTURE_STATE,
    ducs: INITIAL_DUCS_STATE
};
